let language = {
    "COUPON-ALERT-MISSING-TITLE":"Missing coupon code",
    "COUPON-ALERT-MISSING-CONTENT":"Your input coupon code is empty, please enter an available coupon code.",
    "COUPON-ALERT-MAX-TITLE":"Coupon exceeds the maximum limit",
    "COUPON-ALERT-MAX-CONTENT":"You have already used a coupon in the current order and cannot use more coupons.",
    "COUPON-ALERT-DUPLICATE-TITLE":"Duplicate coupon code",
    "COUPON-ALERT-DUPLICATE-CONTENT":"This coupon code has been used in this order already, please change another coupon code and try again.",
    "COUPON-ALERT-REMOVE-TITLE":"Remove coupon code",
    "COUPON-ALERT-REMOVE-CONTENT":"Are you sure you want to remove this coupon code?",
};

export { language }